const initialState = {
  authenticated: false,
  showLoginModal: false,
  defaultBlog: { id: "" }, // Will store user's default blog
  showFooter: true,

  //NEW
  userData: {},
  hasBlog: false,
  isLoggedIn: false,
  mainBlogId: null,
  blogData: null,
  isPhysician: false,
  isVerified: true,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOGIN":
      return {
        ...state,
        authenticated: true,
        showLoginModal: false,
        userData: action.payload,
      };
    case "SET_USER_DATA":
      return {
        ...state,
        authenticated: true,
        showLoginModal: false,
        userData: action.payload.userData,
        // NEW
        isLoggedIn: action.payload.isLoggedIn,
        hasBlog: action.payload.hasBlog,
        mainBlogId: action.payload.mainBlogId,
        blogData: action.payload.blogData,
        isPhysician: action.payload.isPhysician,
      };
    case "SET_VERIFIED":
      return {
        ...state,
        isVerified: action.payload,
      };
    case "SET_BLOG_STATUS":
      return {
        ...state,
        hasBlog: action.payload.hasBlog,
        mainBlogId: action.payload.mainBlogId,
        blogData: action.payload.blogData,
      };
    case "SHOW_LOGIN_MODAL":
      return {
        ...state,
        showLoginModal: true,
      };
    case "HIDE_LOGIN_MODAL":
      return {
        ...state,
        showLoginModal: false,
      };
    case "SET_DEFAULT_BLOG":
      return {
        ...state,
        defaultBlog: action.selectedBlog, // This is the preselected default blog that user sees.
      };
    case "TOGGLE_FOOTER":
      return {
        ...state,
        showFooter: action.value,
      };
    case "RESET_AUTH_STATE":
      return {
        ...initialState,
      };

    default:
      return { ...state };
  }
};

export default auth;
